export const labels = {
	remove: {
		label: "Label.MobileCreator.PhotoPreview.Remove",
		default: "Remove",
	},
	info: {
		label: "Label.MobileCreator.PhotoPreview.Info",
		default: "Info",
	},
} as const;
